export const ORGANIZATION = {
	giveth: 'giveth',
	trace: 'trace',
	givingBlock: 'givingBlock',
	change: 'change',
	endaoment: 'endaoment',
};
